import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/brand";

export default function VentureCard({ venture, index = 0 }) {
  const bgUrl = ASSETS.cityBg[venture.bg === "lasVegas" ? "lasVegas" : venture.bg === "losAngeles" ? "losAngeles" : venture.bg === "newYork" ? "newYork" : venture.bg === "miami" ? "miami" : "dc"];

  return (
    <Link
      to={`/ventures#${venture.id}`}
      data-testid={`venture-card-${venture.id}`}
      className="group relative block overflow-hidden border hairline transition-all duration-500 hover:border-white/30"
      style={{ minHeight: "420px" }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-[1400ms] ease-out group-hover:scale-110"
        style={{ backgroundImage: `url(${bgUrl})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 transition-opacity duration-700 bg-[#050A15]/85 group-hover:bg-[#050A15]/55" aria-hidden="true" />
      <div className="absolute inset-0 grain" aria-hidden="true" />

      <div className="relative z-10 h-full p-8 md:p-10 flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="font-overline text-silver-muted">{String(index + 1).padStart(2, "0")} / 05</span>
          <span className="font-overline text-champagne">{venture.city}</span>
        </div>
        <div>
          <p className="font-overline text-silver-muted mb-3">{venture.region}</p>
          <h3 className="font-display text-3xl md:text-4xl text-silver leading-[1.05] mb-4 tracking-tight">
            {venture.name}
          </h3>
          <p className="font-body text-silver-muted text-sm max-w-md leading-relaxed">
            {venture.tagline}
          </p>
          <div className="mt-8 flex items-center gap-3 text-silver opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <span className="font-overline">Explore</span>
            <div className="h-px w-10 bg-silver"></div>
          </div>
        </div>
      </div>
    </Link>
  );
}
